import { clone } from '@jack-henry/frontend-utils/functions';
import { UserTimeAccessDayDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { TimeAccessType, DayOfWeek } from './time-access.entity';

const nullCompanyUserTimeAccessDay: UserTimeAccessDayDto = {
    timeAccessType: 0, // undefined
    dayOfWeek: 0, // Sunday
    beginTime: '',
    endTime: '',
};

export class UserTimeAccessDay extends DomainEntity<UserTimeAccessDayDto> {
    constructor(dto = clone(nullCompanyUserTimeAccessDay)) {
        super(dto);
    }

    public createDefault(): this {
        return new UserTimeAccessDay(clone(nullCompanyUserTimeAccessDay)) as this;
    }

    public get timeAccessType() {
        return this.dto.timeAccessType as unknown as TimeAccessType;
    }

    public set timeAccessType(value: TimeAccessType) {
        this.dto.timeAccessType = value as number;
    }

    public get dayOfWeek() {
        return this.dto.dayOfWeek as unknown as DayOfWeek;
    }

    public get dayOfWeekName() {
        const dayOfWeekKey = Object.keys(DayOfWeek).find(
            key => DayOfWeek[key as keyof typeof DayOfWeek] === this.dayOfWeek
        );
        return dayOfWeekKey ?? 'Unknown';
    }

    public get beginTime() {
        if (!this.dto.beginTime) {
            return '';
        }
        return this.dto.beginTime;
    }

    public set beginTime(value: string) {
        this.dto.beginTime = value;
    }

    public get endTime() {
        if (!this.dto.endTime) {
            return '';
        }
        return this.dto.endTime;
    }

    public set endTime(value: string) {
        this.dto.endTime = value;
    }
}
